import contact from './contact'

export default {
  name: 'SiteCrm',
  path: 'crm',
  meta: {
    label: 'crm',
    auth: 'crm'
  },
  component: {
    name: 'Crm',
    render(c) {
      return c('router-view')
    }
  },
  children: [contact]
}
